import { defineMessages } from "react-intl";

export const validationEmailErrorMessages = defineMessages({
  invalidFormat: {
    id: "validator.email.invalid-format",
    defaultMessage: "Проверьте правильность email-адреса",
  },
  max: {
    id: "validator.email.max-length",
    defaultMessage: "Максимум 100 символов",
  },
  required: {
    id: "validator.email.required",
    defaultMessage: "Обязательно для заполнения",
  },
});

export const validationPasswordErrorMessages = defineMessages({
  minMax: {
    id: "validator.password.range-length",
    defaultMessage: "длина от {min} до {max} символов",
  },
  oneDigit: {
    id: "validator.password.one-digit",
    defaultMessage: "1 цифра (0-9)",
  },
  oneLetterInLow: {
    id: "validator.password.one-lowercase",
    defaultMessage: "1 строчная буква (a–z)",
  },
  oneLetterInTop: {
    id: "validator.password.one-uppercase",
    defaultMessage: "1 заглавная буква (A–Z)",
  },
  oneSpecialSymbol: {
    id: "validator.password.one-special-symbol",
    defaultMessage: "1 спец. символ (!@#$%^&*()-_+.)",
  },
});

export const validationPhoneErrorMessages = defineMessages({
  invalidFormat: {
    id: "validator.phone.invalid-format",
    defaultMessage: "Проверьте правильность телефона",
  },
});

export const validationRecoveryCodeErrorMessages = defineMessages({
  invalidFormat: {
    id: "validator.recovery-code.invalid-format",
    defaultMessage: "Проверьте правильность кода",
  },
});

export const validationTotpErrorMessages = defineMessages({
  invalidFormat: {
    id: "validator.totp.invalid-format",
    defaultMessage: "Невалидный код",
  },
});

export const validationUrlErrorMessages = defineMessages({
  invalidDomains: {
    id: "validator.url.invalid-domains",
    defaultMessage: "Неверные домены",
  },
  invalidStart: {
    id: "validator.url.invalid-start",
    defaultMessage: "Неверное начало URL",
  },
  max: {
    id: "validator.url.max-length",
    defaultMessage: "Слишком длинный URL",
  },
});

export const validationAddressErrorMessages = defineMessages({
  invalid: {
    id: "validator.address.invalid",
    defaultMessage: "Неверный адрес или сеть",
  },
});

export const validationCoinFormErrorMessages = defineMessages({
  limit: {
    id: "validator.coin-form.limit",
    defaultMessage: "Превышен доступный лимит",
  },
  max: {
    id: "validator.coin-form.max",
    defaultMessage: "Макс.сумма {max} {code}",
  },
  min: {
    id: "validator.coin-form.min",
    defaultMessage: "Мин.сумма {min} {code}",
  },
  paymentSystemMax: {
    id: "validator.coin-form.payment-system-max",
    defaultMessage: "Макс.сумма {paymentSystemMax} {quoteCode}",
  },
  paymentSystemMin: {
    id: "validator.coin-form.payment-system-min",
    defaultMessage: "Мин.сумма {paymentSystemMin} {quoteCode}",
  },
});

export const validationOtpErrorMessages = defineMessages({
  invalidFormat: {
    id: "validator.otp.invalid-format",
    defaultMessage: "Код состоит из 6 цифр",
  },
});

export const validationTxHashErrorMessages = defineMessages({
  required: {
    id: "validator.txhash.required",
    defaultMessage: "Введите хэш транзакции",
  },
});

export const allValidationMessages = [
  validationCoinFormErrorMessages,
  validationEmailErrorMessages,
  validationOtpErrorMessages,
  validationPasswordErrorMessages,
  validationPhoneErrorMessages,
  validationRecoveryCodeErrorMessages,
  validationTotpErrorMessages,
  validationTxHashErrorMessages,
  validationUrlErrorMessages,
  validationAddressErrorMessages,
] as const;
